<template lang="pug">
  .xsell-product
    .product.xs-12.md-6
      .title.xs-12.xs-mb-100m
        p.upper.bold.xs-f-medium.max-at-tweak {{ topLabel }}

      .image.xs-3
        img(:src="item.imagery.thumb.url" :alt="item.imagery.thumb.alt_text")

      .info.xs-8.xs-pl-100m
        .name
          p.upper.xs-f-medium.max-at-tweak {{ item.name }}

        .prod-type.xs-pt-25m.xs-pb-25m
          p.upper.xs-f-xsmall.max-at-tweak {{ productCategory }}

        .description {{ description }}

    .ctas.xs-12.md-6(:class="{ 'xs-mt-150m md-mt-350m lg-mt-400m': !canAttach }")
      template(v-if="canAttach")
        .attachable-ctas.xs-12
          ProductShipOptions(v-model="attachToSub" :one-time-price="item.price" :sub-price="item.sub_price")

      button(@click="$emit('add-product', $event, item, attachToSub)" :class="{ disabled: processing }" data-mr-ass="xsell-order-button").mr-btn.btn-block.xs-f-xsmall.max-at-tweak.add-to-cart {{ buttonText }}

</template>

<script>
  import RoundButton from "../../../RoundButton";
  import MrRadio from "../../../mrRadio";
  import ProductShipOptions from "../../../NextOrEveryOrder/ProductShipOptions";
  export default {
    name: "XsellProduct",

    components: {
      ProductShipOptions,
      MrRadio,
      RoundButton
    },

    data() {
      return {
        attachToSub: false
      }
    },

    props: {
      item: {
        type: Object,
        required: true
      },

      processing: {
        type: Boolean,
        required: true
      },

      canAttach: {
        type: Boolean,
        required: true
      }
    },

    computed: {
      topLabel() {
        return this.item.xsellMembershipDescription || this.item.marketingTagLine || this.item.product_type_display_name;
      },

      productCategory() {
        return this.item.product_type_name || this.item.productTypeName;
      },

      description() {
        return this.item.short_description || this.item.desc;
      },

      buttonText() {
        return `Add to ${this.attachToSub ? "Every" : "Next"} Order`;
      }
    },

    methods: {
      setSubscription(val) {
        this.attachToSub = val;
      }
    },

    mounted() {
      if (this.canAttach) {
        this.attachToSub = true;
      }
    }
  }
</script>

<style scoped lang="stylus">
  .xsell-product
    .image
      img
        width 100%

    .ctas
      padding-left 3em

      .attachable-ctas
        display flex
        align-items flex-start
        flex-wrap wrap
        justify-content space-around

        .round-button
          width 100%

    @media mq-mobile
      .ctas
        padding 1em 0

        .attachable-ctas
          .round-button
            width 49%
            min-height 4.5em

    @media mq-tablet
      .ctas
        padding 1em


</style>